import api from "../service";
import { ApiResponse } from "apisauce";
import { hotToast } from "utils";

const middlewareResponse = (Respose: ApiResponse<any>) => {
  const { data, ok } = Respose;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    return data.data;
  }
  return null;
};

export const requestParameters = async (id: number) => {
  await api.setToken();
  let endPoint: string = `/Report/parameters/${id}`;
  let response: any | null = await api.requestGet(endPoint).then(middlewareResponse);
  return response;
};

export const requestReports = async () => {
  await api.setToken();
  let isValid: object | any | null = await api.requestGet(`Report/GetReportes`);
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      return null;
    }
    return data.data;
  }
  return null;
};

export const setFavorite = async (report: any) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Report/SetFavorito`,
    report
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast("El reporte se guardó en favoritos", "SUCCESS");
    return true;
  }
  return null;
};

export const unsetFavorite = async (report: any) => {
  await api.setToken();
  let isValid: object | any | null = await api.requestPost(
    `Report/UnsetFavorito`,
    report
  );
  const { data, ok } = isValid;
  if (ok) {
    const { code, message } = data;
    if (code != 0) {
      message && hotToast(message, "ERROR");
      return null;
    }
    hotToast("El reporte se eliminó de favoritos", "SUCCESS");
    return true;
  }
  return null;
};

export const getToken = async () => {
  let isValid: object | any | null = await api
    .requestGet(`Report/GetToken`)
    .then(middlewareResponse);
  return isValid;
};
